import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import AuthService from './auth.service';
import ClientService from './client.service';

PouchDB.plugin(PouchDBFind);
export interface NotificationDoc {
  _id: string;
  dueDate: Date;
  payload: any;
  notification_type: 'accueil';
}

@Injectable({
  providedIn: 'root',
})
export default class NotificationService {
  private clientService = inject(ClientService);
  private auth = inject(AuthService);
  private db = new PouchDB('user_' + this.auth.currentUser?.uuid);

  constructor() {
    this.initIndexes();
  }

  initIndexes() {
    this.db.createIndex({
      index: { fields: ['dueDate', 'type', 'status'] },
    });
    this.db.createIndex({
      index: { fields: ['dueDate', 'type', 'status', 'payload.clientUuid'] },
    });
  }
  all(count?: number, type?: 'today' | 'done' | 'next'): Observable<NotificationDoc[]> {
    const now = new Date().toISOString().split('T')[0];

    const selector: any = {};
    if (type) {
      switch (type) {
        case 'today':
          selector.dueDate = {
            $lte: `${now}T23:59:59.999Z`,
          };
          selector.status = { $ne: 'done' };
          break;
        case 'done':
          selector.status = 'done';
          selector.dueDate = {
            $gte: `${now}T00:00:00.000Z`,
            $lte: `${now}T23:59:59.999Z`,
          };
          break;
        case 'next':
          selector.dueDate = {
            $gt: `${now}T23:59:59.999Z`,
          };
          selector.status = { $ne: 'done' };
          break;
      }
    }

    const promise = this.db
      .find({
        selector: {
          type: 'notification',
          ...selector,
        },
        limit: count == 0 ? 25 : count,
        sort: [{ dueDate: 'asc' }],
      })
      .then((res) => {
        let docs = res.docs as unknown as NotificationDoc[];
        const clientUuid = this.clientService.selectedClient();

        if (clientUuid) {
          docs = docs.filter((doc: any) => {
            return (
              doc.payload?.clientUuid === clientUuid || doc.payload?.client?.uuid === clientUuid
            );
          });
        }
        return docs;
      });

    return from(promise);
  }

  getNotification(id: string) {
    const promise = this.db
      .find({
        selector: {
          type: 'notification',
          _id: id,
        },
      })
      .then((res) => {
        return res.docs as unknown as NotificationDoc[];
      });

    return from(promise);
  }

  done(id: string) {
    this.getNotification(id).subscribe((res) => {
      const updatedDoc = {
        ...res[0],
        status: 'done',
      };

      this.save(updatedDoc);
    });
  }

  save(notification: NotificationDoc) {
    const promise = this.db.put(notification);

    return from(promise);
  }
}
